import React from 'react';
import BaseModalComponent from './BaseModal';
import Editor from 'react-tinymce';
//to use history.push
import { withRouter , Link } from 'react-router-dom';

class Post extends BaseModalComponent {
  constructor(props) {
    super(props, props.subModuleName, props.Id, props.ParentComponent);
    this.state.subModuleName = props.subModuleName;
    this.state.key = "id";
  }
  componentWillReceiveProps(props){
    this.state.subModuleName = props.subModuleName;
    this.state.key = "id";
    super.componentWillReceiveProps(props);
  }
  componentDidUpdate() {
    super.componentDidUpdate();
  }
  renderMessages(){
    if (this.isEmpty(this.state.messages)) return null;
    return (<div className="row">
      <div className="col-md-12">
        <div className="box box-info">
          <div className="box-header with-border">
            <h3 className="box-title">لیست خطاهای رخ داده</h3>
          </div>
          <div className="form-horizontal">
            <div className="box-body">
              <div className="form-group">
                {this.state.messages.map(message=>                  
                  <p className="col-sm-12"><span className="text-red" dangerouslySetInnerHTML={{ __html: message }}></span></p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>);
  }
  renderBody() {
    return [
        <div className="row">
          {!this.isBlank(this.state.form_data.record.post_id) ? <a href={"/post/" + this.state.form_data.record.post_id + "/"} target="_blank">مشاهده صفحه خبر بر روی سایت سیولیکا</a> : null}
        </div>
      ,
      <div className="row">
          {this.state.form_data.record.status === 1 ?
            <h4 className="alert alert-warning text-center">شما محتوای این خبر را در تاریخ {this.g2j(this.state.form_data.record.edit_date,6)} ویرایش نموده اید. لطفا تا زمان تایید/رد محتوا منتظر بمانید</h4>
          :null}
          {this.state.form_data.record.status === 3 ?
            <h4 className="alert alert-danger text-center">محتوای ارسالی در تاریخ {this.g2j(this.state.form_data.record.edit_date,6)} از جانب مدیریت سامانه مورد تایید قرار نگرفت
            {!this.isBlank(this.state.form_data.record.note) ? [
              <p dangerouslySetInnerHTML={{ __html: "توضیحات کارشناس سیولیکا: " + this.state.form_data.record.note.replace(/\n/g,"<br/>") }}></p>
            ] : null}
            </h4>
          :null}
      </div>
      ,
      this.renderMessages()
      ,
      <div className="row">
        <div className="col-md-12">
          <div className="box box-info">
            <div className="box-header with-border">
              <h3 className="box-title">جزئیات خبر</h3>
            </div>
            <div className="form-horizontal">
              <div className="box-body">

                <div className="form-group">
                  <label className="col-sm-1 control-label"><span className="text-red">*</span> عنوان</label>
                  <div className="col-sm-11">
                    <input type="text" className="form-control" placeholder="عنوان" onChange={(e) => { this.setFormValue(e, 'title') }} defaultValue={this.state.form_data.record.title} />
                  </div>
                </div>

                <div className="form-group">
                  <label className="col-sm-1 control-label"><span className="text-red">*</span> متن خبر</label>
                  <div className="col-sm-11">
                  <Editor
                        content={this.state.form_data.record.body}
                        config={{
                          language: 'fa_IR',
                          directionality : 'rtl',
                          paste_as_text: true,
                          height: 250,
                          plugins: [
                            'textcolor colorpicker table searchreplace print preview advlist lists paste'
                          ],
                          toolbar:'alignleft rtl ltr forecolor backcolor table format forecolor backcolor searchreplace print preview numlist bullist link',
                          menubar: "",
                        }}
                        onChange={e=>{this.state.form_data.record.body=e.target.getContent()
                        }}
                    />
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    ];
  }
  renderNormalView() {
    return (
      this.state.form_data.status === 4 ?
        this.renderNoLogin()
        :
        this.state.form_data.status === 2 ?
          this.renderNoAccess()
          :
          [
            this.renderBody()
            ,
            <div className="buttonHolder">
              <div className="btn-group">
                <button type="button" className="btn btn-success" onClick={(e) => { this.saveForm(''); }}>ذخیره</button>
              </div>
            </div>
          ]
    );
  }
  render() {
    if (this.state.form_data === null || this.state.form_data === undefined) return null;
    if (this.state.form_data.status === 404) return this.render404();
    return this.renderNormalView();
  }
}
const PostEXP = withRouter(Post);
export default PostEXP;